import React, { useState, useRef } from 'react';

import { rollSkill, rollParanormal } from '../utils/RollDice'

import DiceModal from './DiceModal'

import IconButton from '@material-ui/core/IconButton';
import CasinoIcon from '@material-ui/icons/Casino';

const IconDiceButton = ({ skillName, skillValue, paranormalDice = false }) => {
  const [diceValue, setDiceValue] = useState(-1);
  const [successText, setSuccessText] = useState('Carregando');

  const modalRef = useRef();

  const onButtonClick = () => {
    setDiceValue(-1)
    modalRef.current.handleOpen();
    setTimeout(function () {
      const [resultText, resultNumber] = rollSkill(skillValue)
      setDiceValue(resultNumber)
      setSuccessText(resultText)
    }, 1500);
  }

  const onButtonClickParanormal = () => {
    setDiceValue(-1)
    modalRef.current.handleOpen();
    setTimeout(function () {
      const [resultText, resultNumber] = rollParanormal(skillValue)
      setDiceValue(resultNumber)
      setSuccessText(resultText)
    }, 1500);
  }

  const modalBody = (
    <React.Fragment>
      <h2 id="simple-modal-title">{skillName + ' - ' + successText + ' - ' + diceValue}</h2>
    </React.Fragment>
  )

  return (
    <React.Fragment>
      <IconButton size={"small"} onClick={() => paranormalDice ? onButtonClickParanormal() : onButtonClick()}>
        <CasinoIcon />
      </IconButton>

      <DiceModal
        ref={modalRef}
        diceValue={diceValue}
      >
        {modalBody}
      </DiceModal>
    </React.Fragment>
  );
}

export default IconDiceButton;